export const UNKNOWN_FAIL = 'Sorry, something went wrong';
export const INSUFFICIENT_SALES_DATA = 'Insufficient sales data';
export const NOT_AVAILABLE = 'Not available at location';
